module.exports = __webpack_public_path__ + "img/電気回路_1_3_1.379cbf4d.png";